import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOuder = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      d="M24 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="M24 18a6 6 0 0 1 6 6v10H18V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="M12.81 24a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M18.497 12.427a3.02 3.02 0 0 0 6.006 0l.994.106a4.02 4.02 0 0 1-7.994 0zM25.51 34.03v-9h1v9z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M16.87 28a4 4 0 1 0-8 0v6h8z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOuder);

export default ForwardRef;
